import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { AspxPagePermissionModel } from '../../Models/Domains/Users/AspxPagePermissionModel';

declare var IS_RUNNING_IN_APP_POOL;

export class AspxPagePermissionClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(pageUrl: string): Promise<AspxPagePermissionModel, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/User/AspxPagePermission/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { pageUrl: pageUrl }

    return AjaxWrapper.post<AspxPagePermissionModel, any>(url, data);
  }
}

